import { Menu, MenuButton, MenuList, MenuItem, Button } from "@chakra-ui/react";
import { ChevronDownIcon, CheckCircleIcon, CalendarIcon } from "@chakra-ui/icons";
import { useRouter } from "next/router";
import * as analytics from "utils/analytics";

interface ViewSelectorDropdownProps {
  selectedView: string;
}

export function ViewSelectorDropdown({ selectedView }: ViewSelectorDropdownProps) {
  const router = useRouter();
  const VIEWS = {
    day: "View by day",
    month: "View by month"
  };

  const handleSelect = (view: string) => {
    analytics.log("queue_view_changed", {
      view: view,
    });
    router.push({
      pathname: router.pathname,
      query: { ...router.query, view },
    });
  };

  return (
    <Menu>
      <MenuButton as={Button} rightIcon={<ChevronDownIcon />} leftIcon={<CalendarIcon />} variant="secondary">
        {VIEWS[selectedView] || "View by day"}
      </MenuButton>
      <MenuList>
        {Object.entries(VIEWS).map(([view, label]) => (
          <MenuItem key={view} onClick={() => handleSelect(view)}>
            {view === selectedView && <CheckCircleIcon mr={2} />}
            {label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
} 